export default "__VITE_ASSET__CkpQrT2V__"